import { request } from "../utils/axios-utils";
import axios from "axios";

export const getImageUrlSwatch = async (companyCode, swatchFileName) => {
  try {
    const response = await request({
      url: `/swatch/getputUrl/`,
      method: "GET",
      params: { companyCode, swatchFileName },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const createSwatch = async (company, name, key) => {
  try {
    const response = await request({
      url: `/swatch/create`,
      method: "POST",
      data: { company, name, key },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const putImageToS3 = async (url, file, onProgressCallBack) => {
  try {
    const response = await axios.put(url, file, {
      headers: {
        "Content-Type": file.type,
      },
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percent = Math.floor((loaded * 99) / total);
        onProgressCallBack(percent);
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSwatches = async (data) => {
  try {
    const [_blank, companyCode, pageNum, pageSize, swatchName] = data.queryKey;
    const response = await request({
      url: `/swatch/getSwatches`,
      method: "GET",
      params: { companyCode, pageSize, pageNum, swatchName },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};
